import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["DatasetsCatalogClient"] */ "/app/src/app/datasets/DatasetsCatalogClient.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Navbar"] */ "/app/src/components/Navbar.tsx");
